import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css';

import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'

import VxeUI from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'

import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
import ExcelJS from 'exceljs'

import BatchSearchUsers from '@/views/global-component/batch-select-users/index.vue';
import SingleSearchUsers from '@/views/global-component/single-select-users/index.vue';

// vxe-table全局配置
VxeUITable.setConfig({
    table: {
        size: "mini",
        border: true,
        columnConfig: {
            useKey: true, // 为每一列设置 key 属性
            resizable: true // 列宽拖拽调整
        },
        rowConfig: {
            useKey: true, // 为每一行设置 key 属性
            isHover: true,
        },
        scrollX: {
            enabled: true,  // 启用横向虚拟滚动
            gt: 0
        },
        scrollY: {
            enabled: true,  // 启用纵向虚拟滚动
            gt: 0
        }
    }
})

// vxe-table excel导出插件
VxeUITable.use(VXETablePluginExportXLSX, {
    ExcelJS
})

// 注册全局组件
const app = createApp(App);
app.component('batch-select-users', BatchSearchUsers);
app.component('single-select-users', SingleSearchUsers);

app.use(store).use(router).use(Antd).use(VxeUI).use(VxeUITable).mount('#app')

